import { Component } from '@angular/core';
import { NavController, NavParams, ToastController, LoadingController, ModalController, AlertController, ActionSheetController, Platform } from 'ionic-angular';

import { Item, Api, Tracking, Reviews, Master, Assignment, TrackingFasker  } from '@providers/asset/index';

import { UserMyRadiant as User } from '../../../providers';
// import { FormItemPage, DetailImagePage, AssetDocumentsPage, DetailItemERPPage, AssetReviewsPage } from '../';

import { FormItemFaskerPage } from '../';

declare var cordova:any;

@Component({
  selector: 'page-detail_item',
  templateUrl: 'index.html'
})
export class DetailItemPage {

  item = {
    id                       : '',
    scm_asset_id             : '',
    asset_name               : '',
    asset_classification_id  : '',
    asset_classification_name: '',
    asset_location_id        : '',
    asset_location_name      : '',
    asset_old_code           : '',
    asset_old_code2          : '',
    asset_temp_code          : '',
    asset_new_code           : '',
    asset_new_code2          : '',
    asset_condition_id       : '',
    asset_condition_name     : '',
    estimated_value          : '',
    acquisition_year         : '',
    item_amount              : 1,
    related_to               : '',
    project_code             : ''
  };

  user:any={};

  images:any=[];
  base_url = '';
  url_img  = '';
  tracking = {
    id : 0
  };
  akses:any={};

  data_src = '';

  base_qr : any = '';

  item_tracking : any = '';

  detail_perbaikan :any= {};

  constructor(
    public itemApi      : Item,
    public api          : Api,
    public trackingApi  : Tracking,
    public trackingFaskerApi : TrackingFasker,
    public navCtrl      : NavController,
    public navParams    : NavParams,
    public toastCtrl    : ToastController,
    public loadingCtrl  : LoadingController,
    private alertCtrl   : AlertController,
    public modalCtrl    : ModalController,
    public actSheetCtrl : ActionSheetController,
    public platform     : Platform,
    public userApi      : User,
    public masterApi    : Master
  ) {
    this.user        = this.userApi.data;
    this.akses       = this.userApi.akses;
    this.item.id     = navParams.get('id');
    this.url_img     = this.api.url+'/client/uploads/';
    this.base_url    = this.api.url;
    this.tracking    = navParams.get('tracking');

    this.data_src    = navParams.get('src');
    console.log("data_src => ", this.data_src);

    console.log("user data => ", this.userApi.data);
    console.log("tracking active => ", this.tracking);
  }

  ionViewDidEnter(){
    this.getItemTracking();
    this.getItemByID();
  }

  presentToast(msg){
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    }).present();
  }

  getItemByID(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

      let params = {id: this.item.id};
      let get: any;
      if(this.data_src == 'old'){
        get = this.itemApi.get_detail(params);
      }else{
        get = this.trackingFaskerApi.getDetail(params);
      }
      
      get.subscribe((resp:any) => {
        if(resp.data.length>0){
          this.item = resp.data[0];
          this.getImagesByID();
        }else{
          this.presentToast("Asset tidak terdaftar !")
          this.navCtrl.pop();
        }
        loading.dismiss();
        console.log(resp.data);
      }, (err) => {
        loading.dismiss();
      });

  }

  getItemTracking(){
    let params:any = {
      tracking_id : this.tracking.id
    }
    if(this.data_src == 'old'){
      params.asset_id_old = this.item.id
    }else{
      params.asset_id = this.item.id;
    }
    this.trackingFaskerApi.getTrackedItem(params).subscribe((resp:any) => {
      if(resp.data != ''){
        this.item_tracking = resp.data[0];
      }
      console.log('item tracking => ', this.item_tracking);
    });
  }

  getImagesByID(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params : any =  {
      asset_id: this.item.id
    };
    let get : any;

    if(this.data_src == 'old'){
      get = this.itemApi.getImages(params);
    }else{
      get = this.trackingFaskerApi.getImages(params);
    }

      get.subscribe((resp:any) => {
        if(resp.data.length>0){
          this.images = resp.data;
        }
        loading.dismiss();
      }, (err) => {
        loading.dismiss();
      });
  }

  // viewImage(rec:any = {}) {
  //   let profileModal = this.modalCtrl.create(DetailImagePage, { 
  //     url_image : this.url_img+rec.generated_name,
  //     detail: rec,
  //     assign : this.assign,
  //     assignment_result : this.assignment_result
  //   });
  //   profileModal.present();
  // }

  done(){
    let data:any = {
      location_id   : this.item.asset_location_id,
      asset_item_id_old : this.item.id,
      tracking_id   : this.tracking.id
    }
    if(this.item_tracking.id>0){
      data = this.item_tracking;
    }else{
      data.act = 'scanned';
    }

    let confirm = this.alertCtrl.create({
      title    : 'Konfirmasi',
      subTitle : 'Anda yakin data pada sistem sesuai dengan kondisi fasker anda ?',
      buttons  : [
        {
          text    : 'Tidak',
          handler : () => {
            console.log("No Clicked")
          }
        },
        {
          text    : 'Ya',
          handler : () => {
            console.log("Yes clicked");
            this.toAttachImages();
          }
        }
      ]
    });
    confirm.present();
  }

  edit() {
    let params: any = {
      id  : this.item.id,
      src : this.data_src,
      tracking_active : this.tracking
    }
      this.navCtrl.push(FormItemFaskerPage, params);
  }

  track_item(params){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    this.trackingFaskerApi.post(params).subscribe((resp:any) => {  
      this.presentToast("item scanned");  
      this.navCtrl.pop();
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  }

  toAttachImages(){
    let params: any = {
      id             : this.item.id,
      src            : this.data_src,
      tracking_active: this.tracking,
      tracking_act   : 'scanned'
    }
    this.navCtrl.push(FormItemFaskerPage, params)
  }

}



// WEBPACK FOOTER //
// ./src/pages/opname/detail_item/index.ts